import { createTheme } from '@mui/material/styles';

export const DRAWER_WIDTH = 260;
export const APPBAR_HEIGHT = 75;

const calfTheme = createTheme({
  palette: {
    primary: {
      main: '#8ebf63',
      dark: '#39a82d',
      darker: '#023d03',
      light: '#bee59a',
      contrastText: '#161616',
    },
    secondary:  { main: '#3652ba' },
    success:    { main: '#38a169' },
    background: { default: '#f0f2f5', paper: '#ffffff' },
    text: {
      primary:   '#1f2733',
      secondary: '#718096',
    },
  },
  typography: {
    fontFamily: 'Helvetica, Arial, sans-serif',
    fontSize: 14,
  },
  breakpoints: {
    values: { xs: 0, sm: 600, md: 960, lg: 1200, xl: 1536 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { overflowX: 'hidden', backgroundColor: '#f0f2f5' },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          width: DRAWER_WIDTH,
          boxSizing: 'border-box',
          border: 'none',
          boxShadow: '0px 5px 14px rgba(0, 0, 0, 0.05)',
          borderRadius: '0 20px 20px 0',
          backgroundColor: '#ffffff',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0px 7px 23px rgba(0, 0, 0, 0.05)',
          backgroundImage: 'none',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          marginBottom: 4,
          '&.Mui-selected': {
            backgroundColor: '#1b3bbb',
            color: '#ffffff',
            '& .MuiListItemIcon-root': { color: '#ffffff' },
            '&:hover': { backgroundColor: '#24388a' },
          },
          '&:hover': { backgroundColor: 'rgba(27,59,187,0.06)' },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: { minWidth: 36, color: '#1b3bbb' },
      },
    },
  },
});

export default calfTheme;
